// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'dataviz-heatmap';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <path d='M.576 3.744h5.616V9.36H.576z' />
    <path fill='currentColor' d='M.576 9.36h5.616v5.616H.576zm5.616-5.616h5.616V9.36H6.192z' />
    <path d='M6.192 9.36h5.616v5.616H6.192zm5.616-5.616h5.616V9.36h-5.616zm0 5.616h5.616v5.616h-5.616z' />
  </g>
);

export const viewBox = '0 0 18 18';
